import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { TranslationsKeys } from '../util';
export const DeleteConfirmationModal = ({ onDeleteConfirm, onDeleteModalClose, isModalOpen, showLoader = false, currRow, }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { size: ModalSize.SMALL, title: `${t(TranslationsKeys.MODAL_TITLE_DELETE_INTEGRATION)} ?`, isOpen: isModalOpen, confirmButton: {
            text: t(TranslationsKeys.DELETE_ACTION),
            onConfirm: onDeleteConfirm,
            isLoading: showLoader,
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: onDeleteModalClose },
        React.createElement(Vertical, { hAlignContent: "stretch", grow: true },
            React.createElement("div", { "data-testid": "delete-confirmation-body" },
                React.createElement(Typography, { variant: "p", noMargin: true }, t(TranslationsKeys.MODAL_SUBTITLE_DELETE_INTEGRATION, {
                    name: currRow.name.text,
                }))))));
};
//# sourceMappingURL=delete-confirmation-modal.js.map